/**
 * Sky product card: hovering a variant swatch previews that variant's image on the card;
 * leaving the variant bar restores the product image. Delegated, so it covers cards added later.
 */

/** @param {Element} card */
function clearPreview(card) {
  card.querySelector('.sky-card__img--variant')?.remove();
  card.querySelectorAll('.sky-card__swatch.is-active').forEach((el) => el.classList.remove('is-active'));
}

document.addEventListener('pointerover', (event) => {
  const swatch = event.target instanceof Element && event.target.closest('.sky-card__swatch[data-variant-image]');
  if (!(swatch instanceof HTMLElement)) return;
  const card = swatch.closest('.sky-card');
  const media = card?.querySelector('.sky-card__media');
  if (!card || !media) return;

  clearPreview(card);
  swatch.classList.add('is-active');
  const img = document.createElement('img');
  img.className = 'sky-card__img sky-card__img--variant';
  img.alt = '';
  img.src = swatch.dataset.variantImage || '';
  media.append(img);
});

document.addEventListener('pointerout', (event) => {
  const bar = event.target instanceof Element && event.target.closest('.sky-card__swatches');
  if (!bar || (event.relatedTarget instanceof Node && bar.contains(event.relatedTarget))) return;
  const card = bar.closest('.sky-card');
  if (card) clearPreview(card);
});
